import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import Boton from '@/components/elements/Boton';
import { primary, rojoerror, white } from '@/constants/Colors';
import { esPremium } from '@/util/StringsUtil';
import { Card } from '@mui/material';
import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import { subtitulo } from '@/constants/Dimens';
import Subtitulo from '@/components/elements/Subtitulo';
import Texto from '@/components/elements/Texto';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Productos, pago_producto } from '@/util/Stripe';
import { LoginDatos } from '@/objects/User';
import { comprobarLogro } from '@/util/Gamificacion';
import { IndiceLogro } from '@/objects/Gamificacion';
import { useNotificationContext } from '@/context/NotificationContext';
import { urlWeb } from '@/util/BaseURL';
//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
}

export enum ModoMisLibros {
    MIS_LIBROS = "mis_libros",
    BUSCAR = "buscar"
}

function Premium() {

    const { usersQueries, gamificationQueries } = useServices();

    const [fechaPremium, setFechaPremium] = React.useState<string>();

    const { userData } = useNotificationContext();

    const { t } = useTranslation();

    useEffect(() => {
        cargarPremium();
    }, []);

    function cargarPremium() {
        //Lo obtiene usando el token
        usersQueries?.obtenerDatosUsuario().then((response: AxiosResponse<LoginDatos>) => {
            const fechaPremium = response.data.premium;
            //alert(fechaPremium)
            setFechaPremium(fechaPremium);
            if (esPremium(String(fechaPremium))) {
                comprobarLogro(IndiceLogro.PREMIUM, gamificationQueries!, t, true);
            }
        }
        );
    }

    function comprarPremium(producto: Productos) {
        pago_producto(producto, `${urlWeb}/dashboard/premium`, `${urlWeb}/dashboard/premium`, userData?.email!);
    }

    const cardStyle = {
        padding: "20px",
        width: "500px",
        animation: "pulse 2s 4"
    }

    const separacionVentajas = {
        marginTop: "10px",
        marginBottom: "10px"
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TituloPrincipalH1 texto={t("menu:secciones.premium.titulo")} />
            <div style={{ ...separacionVentajas, textAlign: "center" }}>
                <TituloSeccionH2 fontSize={subtitulo} texto={esPremium(String(fechaPremium)) == true ? t("menu:secciones.premium.ya_eres_usuario_premium", { fecha: String(fechaPremium) }) : t("menu:secciones.premium.descripcion")} />
            </div>
            <section style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                <Card style={cardStyle}>
                    <div>
                        <Subtitulo texto={t("menu:secciones.premium.ventajas.titulo")} />
                        <div style={separacionVentajas}>
                            <Texto>{"🌟" + t("menu:secciones.premium.ventajas.ventaja_1")}</Texto>
                        </div>
                        <div style={separacionVentajas}>
                            <Texto>{"⭐" + t("menu:secciones.premium.ventajas.ventaja_2")}</Texto>
                        </div>
                        <div style={separacionVentajas}>
                            <Texto>{"⭐" + t("menu:secciones.premium.ventajas.ventaja_3")}</Texto>
                        </div>
                        <div style={separacionVentajas}>
                            <Texto>{"⭐" + t("menu:secciones.premium.ventajas.ventaja_4")}</Texto>
                        </div>
                        <div style={separacionVentajas}>
                            <Texto>{"⭐" + t("menu:secciones.premium.ventajas.ventaja_5")}</Texto>
                        </div>
                        <div style={separacionVentajas}>
                            <Texto>{"⭐" + t("menu:secciones.premium.ventajas.ventaja_6")}</Texto>
                        </div>
                        <div style={separacionVentajas}>
                            <Texto>{"⭐" + t("menu:secciones.premium.ventajas.ventaja_7")}</Texto>
                        </div>
                        <div style={separacionVentajas}>
                            <Texto>{"☕" + t("menu:secciones.premium.ventajas.ventaja_8")}</Texto>
                        </div>
                        <div style={separacionVentajas}>
                            <Texto>{t("menu:secciones.premium.ventajas.aclaracion")}</Texto>
                        </div>
                        <div style={{ ...separacionVentajas, textAlign: 'center' }}>
                            <Texto color={rojoerror}>{t("menu:secciones.premium.ventajas.oferta")}</Texto>
                        </div>
                    </div>
                    {!esPremium(String(fechaPremium)) &&
                        <div>
                            <Subtitulo texto={t("menu:secciones.premium.compra_premium")} />
                            <Texto>{t("menu:secciones.premium.noticia_premium")}</Texto>
                            <div style={separacionVentajas}>
                                <Boton color={primary} fullWidth colorTexto={white} startIcon={<ShoppingCartIcon />}
                                    texto={t("menu:secciones.premium.texto_premium", { duracion: "1", precio: "0,99€" })}
                                    onClick={() => { comprarPremium(Productos.PREMIUM_1) }} />
                            </div>
                            <div style={separacionVentajas}>
                                <Boton color={primary} fullWidth colorTexto={white} startIcon={<ShoppingCartIcon />}
                                    texto={t("menu:secciones.premium.texto_premium", { duracion: "2", precio: "1,89€" })}
                                    onClick={() => { comprarPremium(Productos.PREMIUM_1) }} />
                            </div>
                            <div style={separacionVentajas}>
                                <Boton color={primary} fullWidth colorTexto={white} startIcon={<ShoppingCartIcon />}
                                    texto={t("menu:secciones.premium.texto_premium", { duracion: "6", precio: "5,49€" })}
                                    onClick={() => { comprarPremium(Productos.PREMIUM_1) }} />
                            </div>
                            <div style={separacionVentajas}>
                                <Boton color={primary} fullWidth colorTexto={white} startIcon={<ShoppingCartIcon />}
                                    texto={t("menu:secciones.premium.texto_premium", { duracion: "12", precio: "10,99€" })}
                                    onClick={() => { comprarPremium(Productos.PREMIUM_1) }} />
                            </div>
                        </div>
                    }
                </Card>
            </section>

        </section>
    );
}

/* <Boton color={white} colorTexto={primary} startIcon={<AccessAlarmsIcon />} texto={t("menu:secciones.mis_libros.destacar_todos_los_libros")} onClick={() => { destacarTodos() }} />*/
export default Premium;